import { ALLOWED_ENVIRONMENTS } from './constants';
export function getEnvironment() {
  var environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ALLOWED_ENVIRONMENTS.includes(environment) ? environment : 'unknown';
}